import ticketsApiClient from "./base";

// Monitoring API
export const monitoringApi = {
  // Start cron job
  // Cron Job Management
  startCronJob: (schedule) =>
    multiApiClient.post("/tickets/cron/start", null, {
      params: {
        schedule,
      },
    }),
  stopCronJob: () => multiApiClient.post("/tickets/cron/stop"),

  getCronStatus: () => multiApiClient.get("/tickets/cron/status"),
};

export const ticketsApi = {
  // Get all active tickets with pagination
  getAllTickets: (page = 1, limit = 20, title = null, referrer = null) => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });
    if (title) params.append("title", title);
    if (referrer) params.append("referrer", referrer);
    return ticketsApiClient.get(`/tickets/?${params.toString()}`);
  },

  // Get a specific ticket by UUID
  getTicket: (ticketUuid) => ticketsApiClient.get(`/tickets/${ticketUuid}`),
  // Update a specific ticket
  updateTicket: (ticketUuid, updates) =>
    ticketsApiClient.put(`/tickets/${ticketUuid}`, updates),

  // Delete a specific ticket
  deleteTicket: (ticketUuid) =>
    ticketsApiClient.delete(`/tickets/${ticketUuid}`),

  closeTicket: (ticketUuid) =>
    ticketsApiClient.post(`/tickets/${ticketUuid}/close`),

  reopenTicket: (ticketUuid) =>
    ticketsApiClient.post(`/tickets/${ticketUuid}/reopen`),

  // Refresh all tickets from Plenty API
  refreshTickets: () => ticketsApiClient.post("/tickets/refresh"),

  // Get all messages for a specific ticket
  getTicketMessages: (ticketUuid) =>
    ticketsApiClient.get(`/tickets/${ticketUuid}/messages`),
  // Get a single message by UUID
  getSingleMessage: (messageUuid) =>
    ticketsApiClient.get(`/tickets/message/${messageUuid}`),

  getMessageAttachments: (messageUuid) =>
    ticketsApiClient.get(`/tickets/message/${messageUuid}/attachments`, {
      responseType: "blob",
    }),

  // Get AI responses for a ticket
  getTicketAIResponses: (ticketUuid) =>
    ticketsApiClient.get(`/tickets/${ticketUuid}/ai-responses`),

  // Create AI response
  createAIResponse: (ticketUuid, data) =>
    ticketsApiClient.post(`/tickets/${ticketUuid}/ai-responses`, data),
  // Update AI draft on ticket
  updateAIResponse: (ticketUuid, data) =>
    ticketsApiClient.put(`/tickets/${ticketUuid}/ai-response`, data),

  updateMessageResponseCategory: (ticketUuid, messageUuid, data) =>
    ticketsApiClient.put(
      `/tickets/${ticketUuid}/message-responses/${messageUuid}/category`,
      data,
    ),

  // Clear AI draft on ticket
  deleteAIResponse: (ticketUuid) =>
    ticketsApiClient.delete(`/tickets/${ticketUuid}/ai-response`),

  // Send human-reviewed AI draft directly to Plenty
  sendAIResponse: (ticketUuid, data = {}) =>
    ticketsApiClient.post(`/tickets/${ticketUuid}/ai-response/send`, data),

  // Trigger n8n generate workflow for a message
  triggerGenerateWorkflow: (ticketUuid, messageUuid, { cachedMessages } = {}) =>
    ticketsApiClient.post(`/tickets/${ticketUuid}/workflow/generate`, {
      message_uuid: messageUuid,
      ...(cachedMessages?.length ? { cached_messages: cachedMessages } : {}),
    }),

  // Workflow configuration status
  getWorkflowStatus: () => ticketsApiClient.get("/tickets/workflow/status"),

  getWorkflowSettings: () => ticketsApiClient.get("/tickets/workflow/settings"),

  updateWorkflowSettings: (data) =>
    ticketsApiClient.put("/tickets/workflow/settings", data),

  generateWorkflowToken: () =>
    ticketsApiClient.post("/tickets/workflow/settings/generate-token"),

  testWorkflowSettings: (data) =>
    ticketsApiClient.post("/tickets/workflow/settings/test", data),

  // Cron management
  getCronStatus: () => ticketsApiClient.get("/tickets/cron/status"),
  startCronJob: (cronData) =>
    ticketsApiClient.post("/tickets/cron/start", cronData),
  stopCronJob: () => ticketsApiClient.post("/tickets/cron/stop"),
  updateCronSchedule: (cronData) =>
    ticketsApiClient.put("/tickets/cron/schedule", cronData),
};
